import React from 'react'
import { FIGURES } from '../consts/figures'
import FiguresStyle from '../styles/FiguresStyle'

const Figures = () => {
  const figures = FIGURES
  return (
    <FiguresStyle>
      {figures.map(item => {
        const content = (
          <div className="container" key={item.id}>
            <figure>
              <figcaption>
                <h2>{item.title}</h2>
                <p>{item.description}</p>
              </figcaption>
              <img src={item.src} alt="screen" width="414" height="auto" />
            </figure>
          </div>
        )
        return item.id === '2' ? (
          <div className="gradient" key={item.id}>
            {content}
          </div>
        ) : (
          content
        )
      })}
    </FiguresStyle>
  )
}

export default Figures
